// extracted by mini-css-extract-plugin
export default {"container":"ViolenceAndHarassmentPolicyPage_container__4EyYz","labeledList":"ViolenceAndHarassmentPolicyPage_labeledList__wdJYm"};